import {AccountFieldsFragment} from 'api/generated';
import {colors} from 'lib/colors';

export const SYSTEM_TAGS = ['high risk', 'cbd'];

export const getAccountSystemTags = (account: AccountFieldsFragment) => {
  const tags: string[] = account.tags || [];
  return tags.filter((tag) => SYSTEM_TAGS.includes(tag));
};

export const getAccountTags = (account: AccountFieldsFragment) => {
  const tags: string[] = account.tags || [];
  return tags.filter((tag) => !SYSTEM_TAGS.includes(tag));
};

export const getAccountTagColor = (tag: string) => {
  if (SYSTEM_TAGS.includes(tag)) return colors.error;
  return colors.grey;
};
